import React from 'react'
import {Route, Switch} from 'react-router-dom'
import {LinkedInCallback} from "react-linkedin-login-oauth2"
import PrivateRoute from "./components/RouteUtils"
import Affiliates from "./Affiliates";
import Broadcast from "./Broadcast"
import BroadcastEdit from "./BroadcastEdit"
import BroadcastCreativePreview from "./BroadcastCreativePreview"
import BroadcastPagePreview from "./BroadcastPagePreview"
import Broadcasts from "./Broadcasts"
import Clients from "./Clients"
import Resellers from "./Resellers"
import CommissionStatements from "./CommissionStatements"
import CreditTransactions from "./CreditTransactions"
import CreditTransaction from "./CreditTransaction"
import CreditTransactionEdit from "./CreditTransactionEdit"
import AccountEdit from "./AccountEdit"
import Members from "./Members"
import Member from "./Member"
import ReferralCodes from "./ReferralCodes"
import ReferralCode from "./ReferralCode"
import Page403 from "./Page403"
import Page426 from "./Page426"
import Page500 from "./Page500"
import Page503 from "./Page503"
import Page404 from "./Page404"
import Signin from "./Signin"
import Signup from "./Signup"
import SignupRequestAppeal from "./SignupRequestAppeal"
import ConfirmEmailAddress from "./ConfirmEmailAddress"
import SysStatus from "./sysadmin/SysStatus"
import Regions from "./sysadmin/Regions"
import Region from "./sysadmin/Region"
import Countries from "./sysadmin/Countries"
import Country from "./sysadmin/Country"
import Locations from "./sysadmin/Locations"
import Location from "./sysadmin/Location"
import Industries from "./sysadmin/Industries"
import Industry from "./sysadmin/Industry"
import Currencies from "./sysadmin/Currencies"
import Currency from "./sysadmin/Currency"
import RepResellers from "./sysadmin/RepResellers";
import Props from "./sysadmin/Props";
import Prop from "./sysadmin/Prop";
import {MicrosoftAuthCallback} from "./components/MicrosoftAuthCallback"
import BankAccounts from "./sysadmin/BankAccounts";
import BankAccount from "./sysadmin/BankAccount";
import SignupRequests from "./sysadmin/SignupRequests";
import SignupRequest from "./sysadmin/SignupRequest";
import Versions from "./sysadmin/Versions";
import Version from "./sysadmin/Version";
import {WhatsNew} from "./WhatsNew";
import CommissionStatement from "./CommitStatement";
import Account from "./Account";
import MemberEdit from "./MemberEdit";
import {useSolv} from "./components/SolvProvider";

export default function Routes(props) {

  const {env} = useSolv()

  if (["PAUSED", "MAINTENANCE"].includes(env?.serverStatus)) {
    return (
      <Page503/>
    )
  }

  return (
    <Switch>

      <Route path="/signin" component={Signin} exact />
      <Route path="/signin/:magicCode" component={Signin} exact />

      <Route path="/signup" component={Signup} exact />
      <Route path="/signup/appeal/:signupRequestId" component={SignupRequestAppeal} exact />
      <Route path="/signup/:signupCode" component={Signup} exact />
      <Route path="/signup/:signupCode/:magicCode" component={Signup} exact />

      <Route path="/me/:magicCode" component={ConfirmEmailAddress} exact />

      <Route path="/forbidden" component={Page403} />
      <Route path="/upgrade" component={Page426} />
      <Route path="/error" component={Page500} />
      <Route path="/unavailable" component={Page503} />
      <Route path="/403" component={Page403} />
      <Route path="/426" component={Page426} />
      <Route path="/500" component={Page500} />
      <Route path="/503" component={Page503} />
      <Route path="/whatsnew/:versionCode" component={WhatsNew} />
      <Route path="/whatsnew" component={WhatsNew} />

      <Route path="/linkedin" component={LinkedInCallback} exact />

      <Route path="/authcb/ms/" component={MicrosoftAuthCallback} exact />

      {/*  Logged-in user routes  */}

      <PrivateRoute path="/" component={Account} exact />
      <PrivateRoute path="/_new" component={AccountEdit} exact />
      <PrivateRoute path="/_edit" component={AccountEdit} exact />
      <PrivateRoute path="/affiliates" component={Affiliates} exact />
      <PrivateRoute path="/clients" component={Clients} exact />
      <PrivateRoute path="/resellers" component={Resellers} exact />
      <PrivateRoute path="/broadcasts" component={Broadcasts} exact />
      <PrivateRoute path="/broadcasts/_new" component={BroadcastEdit} exact />
      <PrivateRoute path="/broadcasts/:broadcastId" component={Broadcast} exact />
      <PrivateRoute path="/broadcasts/:broadcastId/creative" component={BroadcastCreativePreview} exact />
      <PrivateRoute path="/broadcasts/:broadcastId/page" component={BroadcastPagePreview} exact />
      <PrivateRoute path="/broadcasts/:broadcastId/_edit" component={BroadcastEdit} exact />
      <PrivateRoute path="/broadcasts/:broadcastId/_publish" component={BroadcastEdit} exact />
      <PrivateRoute path="/members" component={Members} exact />
      <PrivateRoute path="/members/_new" component={MemberEdit} exact />
      <PrivateRoute path="/members/:userId" component={Member} exact />
      <PrivateRoute path="/members/:userId/_edit" component={MemberEdit} exact />
      <PrivateRoute path="/credits" component={CreditTransactions} exact />
      <PrivateRoute path="/credits/:creditTransactionId" component={CreditTransaction} exact />
      <PrivateRoute path="/credits/:creditTransactionId/_edit" component={CreditTransactionEdit} exact />
      <PrivateRoute path="/refcodes" component={ReferralCodes} exact />
      <PrivateRoute path="/commissions" component={CommissionStatements} exact />
      <PrivateRoute path="/commissions/:commissionStatementId" component={CommissionStatement} exact />
      <PrivateRoute path="/profile" component={Member} exact />
      <PrivateRoute path="/me" component={Member} exact />
      <PrivateRoute path="/me/_edit" component={MemberEdit} exact />

      <PrivateRoute path="/sys" component={SysStatus} exact />
      <PrivateRoute path="/sys/regions" component={Regions} exact />
      <PrivateRoute path="/sys/regions/:regionId" component={Region} exact />
      <PrivateRoute path="/sys/countries" component={Countries} exact />
      <PrivateRoute path="/sys/countries/:countryCode" component={Country} exact />
      <PrivateRoute path="/sys/locations" component={Locations} exact />
      <PrivateRoute path="/sys/locations/:locationId" component={Location} exact />
      <PrivateRoute path="/sys/industries/" component={Industries} exact />
      <PrivateRoute path="/sys/industries/:industryId" component={Industry} exact />
      <PrivateRoute path="/sys/currencies/" component={Currencies} exact />
      <PrivateRoute path="/sys/currencies/:currencyCode" component={Currency} exact />
      <PrivateRoute path="/sys/represellers/" component={RepResellers} exact />
      <PrivateRoute path="/sys/bankaccounts/" component={BankAccounts} exact />
      <PrivateRoute path="/sys/bankaccounts/:bankAccountId" component={BankAccount} exact />
      <PrivateRoute path="/sys/props/" component={Props} exact />
      <PrivateRoute path="/sys/props/:propsId" component={Prop} exact />
      <PrivateRoute path="/sys/signupRequests/" component={SignupRequests} exact />
      <PrivateRoute path="/sys/signupRequests/:signupRequestId" component={SignupRequest} exact />
      <PrivateRoute path="/sys/versions/" component={Versions} exact />
      <PrivateRoute path="/sys/versions/:versionId" component={Version} exact />

      <PrivateRoute path="/:tenantId" component={Account} exact/>
      <PrivateRoute path="/:tenantId/_new" component={AccountEdit} exact/>
      <PrivateRoute path="/:tenantId/_edit" component={AccountEdit} exact/>
      <PrivateRoute path="/:tenantId/affiliates" component={Affiliates} exact />
      <PrivateRoute path="/:tenantId/clients" component={Clients} exact/>
      <PrivateRoute path="/:tenantId/resellers" component={Resellers} exact/>
      <PrivateRoute path="/:tenantId/broadcasts" component={Broadcasts} exact />
      <PrivateRoute path="/:tenantId/broadcasts/_new" component={BroadcastEdit} exact />
      <PrivateRoute path="/:tenantId/broadcasts/:broadcastId" component={Broadcast} exact />
      <PrivateRoute path="/:tenantId/broadcasts/:broadcastId/creative" component={BroadcastCreativePreview} exact />
      <PrivateRoute path="/:tenantId/broadcasts/:broadcastId/page" component={BroadcastPagePreview} exact />
      <PrivateRoute path="/:tenantId/broadcasts/:broadcastId/_edit" component={BroadcastEdit} exact />
      <PrivateRoute path="/:tenantId/broadcasts/:broadcastId/_publish" component={BroadcastEdit} exact />
      <PrivateRoute path="/:tenantId/credits" component={CreditTransactions} exact />
      <PrivateRoute path="/:tenantId/credits/:creditTransactionId" component={CreditTransaction} exact />
      <PrivateRoute path="/:tenantId/credits/:creditTransactionId/_edit" component={CreditTransactionEdit} exact />
      <PrivateRoute path="/:tenantId/members" component={Members} exact />
      <PrivateRoute path="/:tenantId/members/_new" component={MemberEdit} exact />
      <PrivateRoute path="/:tenantId/members/:userId" component={Member} exact />
      <PrivateRoute path="/:tenantId/members/:userId/_edit" component={MemberEdit} exact />
      <PrivateRoute path="/:tenantId/refcodes" component={ReferralCodes} exact />
      <PrivateRoute path="/:tenantId/refcodes/:referralCode" component={ReferralCode} exact />
      <PrivateRoute path="/:tenantId/commissions" component={CommissionStatements} exact />
      <PrivateRoute path="/:tenantId/commissions/:commissionStatementId" component={CommissionStatement} exact />

      <Route component={Page404} />

    </Switch>
  )
}